import VueRouter from "vue-router";
import multiguard from 'vue-router-multiguard';
import EnrollmentApp from './pages/enrollment/EnrollmentApp.vue';
import DashboardApp from './pages/dashboard/DashboardApp.vue';
import Profile from "./pages/Profile.vue";
import Login from './pages/Login.vue';
import ResetPasswordRequest from "./pages/ResetPasswordRequest.vue";
import ResetPasswordComplete from "./pages/ResetPasswordComplete.vue";
import NotFound from './pages/NotFound.vue';
import Survey from './pages/Survey.vue';
import store from "./store";

export default function (base = "/") {

  const checkIfAlreadyLoggedIn = (to, from, next) => {
    // if already logged in, redirect to /study
    if (store.getters.getParticipant) {
      next({name: 'home'});
    } else {
      next();
    }
  };
  // if ppt login is disabled, redirect to 404
  const checkIfLoginEnabled = (to, from, next) => {
    if (!store.getters.isLoginEnabled) {
      next({name: 'home'});
    } else {
      next();
    }
  }
  const router = new VueRouter({
    // TODO move into config file for reuse
    mode: "history",
    base,
    routes: [
      {
        name: 'home',
        path: '/',
        beforeEnter: (to, from, next) => {
          if (store.getters.isStartedParticipant && store.getters.isArmWithPortal) {
            // redirect to Dashboard
            next({name: 'dashboard'});
          } else {
            // redirect to Enrollment
            next({name: 'enrollment'});
          }
        }
      },
      {
        name: 'enrollment',
        path: '/enroll',
        component: EnrollmentApp,
        props: () => ({
          studyId: store.state.studyId,
          initialAccount: store.state.account,
          initialParticipantId: store.getters.getParticipant && store.getters.getParticipant.id,
          initialStudy: store.state.study
        }),
        beforeEnter: async (to, from, next) => {
          // if they are started in an arm that has the portal enabled, redirect them to the dashboard
          if (store.getters.isStartedParticipant && store.getters.isArmWithPortal) {
            // redirect to Dashboard
            next({name: 'dashboard'});
          } else {
            await store.dispatch('LOAD_REDIRECT_SURVEYS');
            if (store.state.dashboardSurveys.length > 0) {
              let surveys = store.state.dashboardSurveys;
              // adding the date query string is just to get the `afterEach` method to be hit, setting loading back to false
              return next({name: 'survey', params: {api_id: surveys[0].api_id}, query: {q: Date.now()}});
            }
            next();
          }
        }
      },
      {
        name: 'dashboard',
        path: '/dashboard/:path?',
        component: DashboardApp,
        beforeEnter: async (to, from, next) => {
          // if logged in, but not a started ppt
          if (store.getters.getParticipant && (!store.getters.isStartedParticipant || !store.getters.isArmWithPortal)) {
            // redirect to Enrollment
            next({name: 'enrollment'});
          }
          // if not logged in, redirect to login
          else if (!store.getters.isStartedParticipant) {
            next({name: 'login'});
          } else {
            await store.dispatch('LOAD_REDIRECT_SURVEYS');
            // Check for any dashboardSurveys and redirect users to take the survey
            if (store.state.dashboardSurveys.length > 0) {
              let surveys = store.state.dashboardSurveys;
              // adding the date query string is just to get the `afterEach` method to be hit, setting loading back to false
              return next({name: 'survey', params: {api_id: surveys[0].api_id}, query: {q: Date.now()}});
            }
            next();
          }
        }
      },
      {
        name: 'survey',
        path: '/survey/:api_id',
        component: Survey,
      },
      {
        name: 'profile',
        path: '/profile',
        component: Profile
      },
      {
        name: 'login',
        path: '/login',
        component: Login,
        beforeEnter: multiguard([checkIfLoginEnabled, checkIfAlreadyLoggedIn])
      },
      {
        name: 'reset-password',
        path: '/reset-password',
        component: ResetPasswordRequest,
        props: () => ({
          studyId: store.state.studyId,
          study: store.state.study
        }),
        beforeEnter: multiguard([checkIfLoginEnabled, checkIfAlreadyLoggedIn])
      },
      {
        name: 'reset-password-complete',
        path: '/reset-password/:validateCode',
        component: ResetPasswordComplete,
        props: true,
        beforeEnter: multiguard([checkIfLoginEnabled, checkIfAlreadyLoggedIn])
      },
      {
        name: 'logout',
        path: '/logout',
        beforeEnter: async function (to, from, next) {
          await store.dispatch('LOGOUT');
          // full page load to clear out wonky stuff
          document.location = router.resolve({name: 'login'}).href;
        }
      },
      {
        name: '404',
        path: '/404',
        component: NotFound
      },
      {
        path: '*',
        redirect: '/404'
      }
    ],
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return {x: 0, y: 0}
      }
    }
  });

  router.beforeEach(async (to, from, next) => {
    // some of these actions don't need to block the page load, so only await the ones that need sequencing
    store.commit('SET_LOADING', true);
    store.commit('CLOSE_PANELS');
    await store.dispatch('API_INIT');
    await store.dispatch('LOAD_STUDY');
    await store.dispatch('LOAD_ACCOUNT');
    store.dispatch('SET_LOCALE');
    await store.dispatch('LOAD_NAVIGATION_PAGES');
    store.dispatch('LOAD_DASHBOARD_NOTIFICATIONS');
    store.dispatch('POLL_NOTIFICATIONS');
    next();
  });

  router.afterEach((to, from) => {
    store.commit('SET_LOADING', false);
    store.commit('SET_SHOW_HEADER', true);
  });

  return router;
}


